
<div style="display:flex">
  <div class="speech-text" *ngIf="flag"  (click)="startRecognition()">
    <mat-icon style="color:#727272">mic</mat-icon>
  </div>
  <div class="speech-text"   *ngIf="!flag"  (click)="stopRecognition()">
    <mat-icon style="color:red">mic</mat-icon>
  </div>
  </div>
  
  